import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { CustomToggleComponent } from './custom-toggle.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [CustomToggleComponent],
  imports: [
    CommonModule,
    MatTooltipModule,
    MatSlideToggleModule,
    FormsModule
  ]
})
export class CustomToggleModule { }
